<template>
    <v-dialog
                v-model="dialog.show"
                width="750px"
                class="rounded-lg"
        >
            <v-card class="pa-8 elevation-0"
                    tile
                    min-height="400"
                
            >
                    <v-card-title class="headline pt-0 mx-auto justify-center">
                        <h2 class="font-weight-bolder text-left font-family-1 font-size-30">{{titleDialog}} con Archivo {{formatFile.toUpperCase()}}</h2>
                    </v-card-title>
                <v-card-text>
                  
                  
                  <v-row justify="start" align="center" class="mt-10 border-bottom-1 align-center">
                      <v-col class="text-center" >
                      <v-file-input v-model="file" 
                      prepend-icon="mdi-file-pdf-outline" 
                      label="Seleccionar archivo PDF" outlined dense>
                            <template v-slot:selection="{ text }">
                                <v-chip
                                    small
                                    label
                                    color="primary"
                                >
                                    {{ text }}
                                </v-chip>
                            </template>
                        </v-file-input>
                        
                    <v-btn color="primary"
                       raised
                       dark
                       @click="dialog.show = false"
                       class="pa-6 mt-6 mb-12">{{titleDialog}}</v-btn>
                      </v-col>
                  </v-row>
               
                </v-card-text>
                <v-card-actions class="justify-center">
                   <v-icon size="60" color="green" class="mr-4">mdi-microsoft-excel</v-icon>
                   <a href="#">Descarga plantilla para carga masiva<br> de puntos de retito</a>

                </v-card-actions>

            </v-card>

        </v-dialog>
</template>

<script>
    export default {
        name: 'UploadFileComponent',
        props:['titleDialog','formatFile'],
        data() {
            return {
                 dialog:{
                     show:false,
                     file:null
                 }
            }
        }
    }
</script>